"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function ClientDimensionFromJSON(json) {
    return ClientDimensionFromJSONTyped(json, false);
}
exports.ClientDimensionFromJSON = ClientDimensionFromJSON;
function ClientDimensionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !runtime_1.exists(json, 'category') ? undefined : json['category'],
        'height': !runtime_1.exists(json, 'height') ? undefined : json['height'],
        'length': !runtime_1.exists(json, 'length') ? undefined : json['length'],
        'weight': !runtime_1.exists(json, 'weight') ? undefined : json['weight'],
        'width': !runtime_1.exists(json, 'width') ? undefined : json['width'],
    };
}
exports.ClientDimensionFromJSONTyped = ClientDimensionFromJSONTyped;
function ClientDimensionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'height': value.height,
        'length': value.length,
        'weight': value.weight,
        'width': value.width,
    };
}
exports.ClientDimensionToJSON = ClientDimensionToJSON;
/**
* @export
* @enum {string}
*/
var ClientDimensionCategoryEnum;
(function (ClientDimensionCategoryEnum) {
    ClientDimensionCategoryEnum["UNDERSIZED"] = "UNDERSIZED";
    ClientDimensionCategoryEnum["S"] = "S";
    ClientDimensionCategoryEnum["M"] = "M";
    ClientDimensionCategoryEnum["L"] = "L";
    ClientDimensionCategoryEnum["OVERSIZED"] = "OVERSIZED";
})(ClientDimensionCategoryEnum = exports.ClientDimensionCategoryEnum || (exports.ClientDimensionCategoryEnum = {}));
